import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { FeedbacksComponent } from './feedbacks/feedbacks.component';
import { NgbModule, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables,
} from 'ng2-charts';
import { ChartsComponent } from './charts/charts.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from 'src/material.module';
import { ColorPipe } from './charts/color.pipe';
import { LoginComponent } from './login/login.component';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from './services/api.service';
import { MeetingComponent } from './meeting/meeting.component';
import { AuthGuard } from './services/auth.gaurd';
import { AlertsComponent } from './alerts/alerts.component';
import { HeaderComponent } from './header/header.component';
import { EmotionalanalysisComponent } from './emotionalanalysis/emotionalanalysis.component';
import { JoinCallComponent } from './join-call/join-call.component';
import { VideocallComponent } from './videocall/videocall.component';
import { LocalvideoComponent } from './localvideo/localvideo.component';
import { RemotevideoComponent } from './remotevideo/remotevideo.component';
import { AudiocallComponent } from './audiocall/audiocall.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';

@NgModule({
  declarations: [
    AppComponent,
    FeedbacksComponent,
    ChartsComponent,
    LoginComponent,
    AlertsComponent,
    ColorPipe,
    MeetingComponent,
    HeaderComponent,
    EmotionalanalysisComponent,
    JoinCallComponent,
    AudiocallComponent,
    VideocallComponent,
    LocalvideoComponent,
    RemotevideoComponent,
    ErrorpageComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbRatingModule,
    BaseChartDirective,
    BrowserAnimationsModule,
    AngularMaterialModule,
    HttpClientModule,
  ],
  providers: [ApiService, AuthGuard, provideCharts(withDefaultRegisterables())],
  bootstrap: [AppComponent],
})
export class AppModule {}
